<template>
  <div id="knowledgeModal" class="modal" :class="{ 'is-active' : isActive }">
    <div class="modal-background"></div>

    <div class="modal-content">
      <div v-if="knowledge" class="card">
        <div v-if="hasImage" class="card-image">
          <figure class="image">
            <img :src="isImage(knowledge.attachments[0].file) ? knowledge.attachments[0].file : placeholder" alt="Image not found">
          </figure>
        </div>

        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">{{ knowledge.title }}</p>
            </div>
          </div>

          <div class="content" v-html="knowledge.description"></div>

          <div v-show="knowledge.attachments.length" class="content">
            <h2 class="title is-5">Afbeeldingen en documenten</h2>
            <figure v-for="attachment in knowledge.attachments" class="attachment">
              <img :src="isImage(attachment.file) ? attachment.file : placeholder" alt="Image not found">
              <h3 v-show="hasName(image)" class="subtitle is-6">{{ image.name }}</h3>
              <div v-show="hasCaption(image)" class="content" v-html="image.caption"></div>
            </figure>
          </div>

          <div class="content">
            <button type="button" class="button" @click="add">Toevoegen aan collectie</button>
          </div>
        </div>
      </div>
    </div>

    <button class="modal-close is-large" aria-label="close" @click="close"></button>
  </div>
</template>

<script>
export default {
  props: [
    'knowledge'
  ],
  data () {
    return {
      placeholder: 'static/assets/images/pdf.png'
    }
  },
  computed: {
    isActive () {
      return this.knowledge !== null
    },
    hasImage () {
      return this.knowledge.attachments.length > 0
    }
  },
  methods: {
    add () {
      this.$emit('add')
    },
    close () {
      this.$emit('close')
    },
    isImage (filename) {
      let images = [
        'jpeg',
        'jpg',
        'png'
      ]

      return images.includes(filename.split('.').pop())
    },
  }
}
</script>

<style scoped>
  .image .subtitle {
    margin-top: 0 !important;
    margin-bottom: 5px !important;
    text-align: left;
  }

  .image .content {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/knowledge/KnowledgeModal.vue